import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-life-sciences-medicine-and-pharma',
  templateUrl: './life-sciences-medicine-and-pharma.component.html',
  styleUrls: ['./life-sciences-medicine-and-pharma.component.scss']
})
export class LifeSciencesMedicineAndPharmaComponent implements OnInit {


  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle("Trinka 企業版｜生命科學、醫療與製藥產業");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka 的先進 AI 能掌握醫療與科學寫作中微妙的語境與專業精準度，協助您高效撰寫關鍵文件。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "Trinka 企業版｜生命科學、醫療與製藥產業" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka 的先進 AI 能掌握醫療與科學寫作中微妙的語境與專業精準度，協助您高效撰寫關鍵文件。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/enterprise/life-sciences-medicine-and-pharma' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise/life-sciences-medicine-and-pharma' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/life-sciences-medicine-and-pharma' });
  }

  globalSliderData: any[] = [
    { "imgSrc": "/assets/images/client_logos/j-j.png", "altText": "johnsons" },
    { "imgSrc": "/assets/images/client_logos/cigna.png", "altText": "cigna" },
    { "imgSrc": "/assets/images/client_logos/novartis.png", "altText": "novartis" },
    { "imgSrc": "/assets/images/client_logos/merck.png", "altText": "merck" },
    { "imgSrc": "/assets/images/client_logos/abbvie.png", "altText": "abbvie" },
    { "imgSrc": "/assets/images/client_logos/amgen.png", "altText": "amgen" },
    { "imgSrc": "/assets/images/client_logos/biogen.png", "altText": "biogen" },
    { "imgSrc": "/assets/images/client_logos/who.png", "altText": "who" },
    { "imgSrc": "/assets/images/client_logos/accelera.png", "altText": "accelera" },
    { "imgSrc": "/assets/images/client_logos/pfizer.png", "altText": "pfizer" }
  ];
  
}
